module.exports = __WEBPACK_EXTERNAL_MODULE_0__;


//////////////////
// WEBPACK FOOTER
// external {"root":"Mobx","commonjs2":"mobx","commonjs":"mobx","amd":"mobx"}
// module id = 0
// module chunks = 0


// WEBPACK FOOTER //
// webpack:///external {"root":"Mobx","commonjs2":"mobx","commonjs":"mobx","amd":"mobx"}